export const REVIEWS_AND_ANSWERS_STATISTICS_TABLE_DEFAULT_PAGE_SIZE = 20;
